import React, { useEffect, useRef } from 'react';
import './Changelog.css';

const Changelog = ({ version, changes, date, onClose }) => {
  const changelogRef = useRef(null);

  // Handle clicks outside the changelog to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (changelogRef.current && !changelogRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="changelog-overlay">
      <div className="changelog-container" ref={changelogRef}>
        <div className="changelog-header">
          <h3>What's New in v{version}</h3>
          <button className="changelog-close-btn" onClick={onClose}>×</button>
        </div>
        <div className="changelog-content">
          <div className="changelog-version-date">{date}</div>
          <ul>
            {changes.map((change, index) => (
              <li key={index}>{change}</li>
            ))}
          </ul>
        </div>
        <div className="changelog-footer">
          <p>Click outside to dismiss</p>
        </div>
      </div>
    </div>
  );
};

export default Changelog; 